import { lazy, Suspense } from 'react';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';
import { NoNavLayout, DashboardLayout } from 'src/layouts/dashboard';

import RequireAuth from './components/RequireAuth';
import ExternalRedirect from './components/ExternalRedirect';

export const McsPage = lazy(() => import('../pages/mcs'));
export const DetailPage = lazy(() => import('../pages/details'));
export const LoginPage = lazy(() => import('../pages/login'));
export const RegisterPage = lazy(() => import('../pages/register'));
export const RedirectPage = lazy(() => import('../pages/redirect'));
export const PatientsPage = lazy(() => import('../pages/patients'));
export const Page404 = lazy(() => import('../pages/page-not-found'));
export const ScreeningPage = lazy(() => import('../pages/screening'));
export const InvitesPage = lazy(() => import('../pages/invites'));
export const ResetPage = lazy(() => import('../pages/reset'));
export const InstructionsPage = lazy(() => import('../pages/instructions'));
export const ReviewsPage = lazy(() => import('../pages/review'));
export const DemoPage = lazy(() => import('../pages/demo'));
export const TutorPage = lazy(() => import('../pages/tutor'));
export const ChatPage = lazy(() => import('../pages/chat'));

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      element: (
        <DashboardLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      ),
      children: [
        { path: 'patients', element: <RequireAuth element={<PatientsPage id="patients" />} /> },
        { path: 'screening', element: <RequireAuth element={<ScreeningPage id="screening" />} /> },
        { path: 'reviews', element: <RequireAuth element={<ReviewsPage id="reviews" />} /> },
        {
          path: 'details/:patientId',
          element: <RequireAuth element={<DetailPage id="details" />} />,
        },
        {
          path: 'screening/:patientId',
          element: <RequireAuth element={<DetailPage id="screening" />} />,
        },
        {
          path: 'reviews/:patientId',
          element: <RequireAuth element={<DetailPage id="reviews" />} />,
        },
        { path: 'invites', element: <RequireAuth element={<InvitesPage id="invites" />} /> },
        {
          path: 'instructions/staff/about?',
          element: <RequireAuth element={<InstructionsPage id="instructions" />} />,
        },
        { path: 'demo', element: <RequireAuth element={<DemoPage id="demo" />} /> },
        { path: 'chat', element: <RequireAuth element={<ChatPage id="chat" />} /> },
      ],
    },
    {
      element: (
        <NoNavLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </NoNavLayout>
      ),
      children: [
        { index: true, element: <RequireAuth element={null} /> },
        {
          path: 'patients/redirect/',
          element: <RequireAuth element={<RedirectPage id="redirect" />} />,
        },
        { path: ':lang?/login', element: <LoginPage /> },
        { path: ':lang?/register/:preProject?', element: <RegisterPage /> },
        { path: ':lang?/password/reset?/confirm?/:uid?/:token?', element: <ResetPage /> },
      ],
    },
    { path: 'tutor', element: <TutorPage /> },
    {
      path: '404',
      element: <Page404 />,
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
    {
      path: 'app',
      element: <ExternalRedirect href={`https://app${import.meta.env.DEV ? '-test' : ''}.megi.ai`} />,
    },
  ]);

  return routes;
}
